/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'
import Popup from '../popup'
import SelectLabel from '../selectLabel'
import { SelectLabelProps } from '../selectLabel/interface'
import { DAC } from '../interface'
import './selectWrap.css'

interface PopupProps {
  root?(): Element;
  scrollRoot?(): Element;
  visible?: boolean;
  onVisibleChange?(ev: DAC.Event<boolean>): void;
  trigger?: 'hover' | 'click';
  position?:
  | 'topLeft'
  | 'top'
  | 'topRight'
  | 'rightTop'
  | 'right'
  | 'rightBottom'
  | 'bottomRight'
  | 'bottom'
  | 'bottomLeft'
  | 'leftBottom'
  | 'left'
  | 'leftTop';
  animation?: 'Opacity' | 'Scale' | 'Fade' | string;
}

export declare interface SelectWrapProps<V>
  extends SelectLabelProps<V>,
  PopupProps {
  className?: string;
  popupClassName?: string;
  style?: React.CSSProperties;
  multi?: boolean;
  disabled?: boolean & ((item: DAC.OptionItem) => boolean);
  modify?: React.ReactNode | ((data?: any[]) => React.ReactNode);
  children?: (props: {
    onClose?: () => void;
    visible?: boolean;
  }) => React.ReactNode;
  visible?: boolean;
  onVisibleChange?(ev: DAC.Event<boolean>): void;
  contentWrapStyle?: React.CSSProperties;
}

const SelectWrap = <V = unknown>(props: SelectWrapProps<V | V[]>) => {
  const {
    position = 'bottomLeft',
    root,
    scrollRoot,
    multi,
    value,
    onChange,
    className,
    style,
    disabled,
    trigger,
    animation = 'Fade',
    modify,
    children,
    visible: visibleProp,
    onVisibleChange,
    popupClassName,
    contentWrapStyle,
    data,
    ...selectProps
  } = props

  const [innerVisible, setInnerVisible] = useState(visibleProp)

  useEffect(() => { setInnerVisible(visibleProp) }, [visibleProp])

  const visible = visibleProp !== undefined ? visibleProp : innerVisible

  return (
    <span className="zySelectWrap">
      {modify
        ? (typeof modify === 'function' ? modify?.(data) : modify)
        : multi ? (
          <SelectLabel.Multi<V>
            value={value as V[]}
            onChange={onChange}
            className={className}
            style={style}
            open={visible}
            disabled={disabled === true}
            data={data}
            {...selectProps}
          />
        ) : (
          <SelectLabel<V>
            value={value as V}
            onChange={onChange}
            className={className}
            style={style}
            open={visible}
            disabled={disabled === true}
            data={data}
            {...selectProps}
          />
        )}
      {disabled === true ? null : (
        <Popup
          root={root}
          scrollRoot={scrollRoot}
          visible={visible}
          onVisibleChange={(ev) => {
            onVisibleChange?.(ev)
            setInnerVisible(ev.value)
          }}
          position={position}
          trigger={trigger}
          animation={animation}
          className={popupClassName}
        >
          <div className="zySelectContentWrap" style={contentWrapStyle}>
            <div className="zySelectContent">
              {children?.({
                onClose: () => {
                  onVisibleChange?.({ value: false })
                  setInnerVisible(false)
                },
                visible,
              })}
            </div>
          </div>
        </Popup>
      )}
    </span>
  )
}

SelectWrap.defaultProps = {
  trigger: 'click',
}

export default SelectWrap
